// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active-order-enter-active[data-v-647705fc]{transition:all .2s ease}.active-order-leave-active[data-v-647705fc]{transition:all .2s cubic-bezier(1,.5,.8,1)}.active-order-enter[data-v-647705fc],.active-order-leave-to[data-v-647705fc]{transform:translateX(10px);opacity:0}.loading-anim-enter-active[data-v-647705fc],.loading-anim-leave-active[data-v-647705fc]{transition:opacity .2s ease}.loading-anim-enter[data-v-647705fc],.loading-anim-leave-to[data-v-647705fc]{opacity:0}", ""]);
// Exports
module.exports = exports;
